import * as React from 'react';
import {Component, deps, inject, observer} from '../lib/component';
import {DiscoverPage} from './discover';
import {classes, style} from 'typestyle';
import {percent, px} from 'csx';
import PrismicDOM from 'prismic-dom';
import {TypeformPopupButton} from '../components/social/typeform-popup-button';
import {PageHeader} from '../components/page-header';
import {TextNoOrphan} from '../components/text-no-orphan';
import {colorBrand,} from '../theme/color';
import {PageHomeCTASeparator} from '../components/page-home-cta-separator';
import {ButtonPill} from '../components/button-pill';
import {constantGoldenRatio} from '../theme/constant';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {ResponsiveImageTile} from '../components/responsive-image-tile';
import {LearnPage} from './learn';
import MainWrapper from '../components/main-wrapper';

export interface CareersPageProps {}

@inject(deps) @observer
export class CareersPage extends Component<CareersPageProps> {
  render() {
    const model = this.props.model.page.careers;
    const {preloadImage} = this.props.controller.image;
    const {handleClickLink} = this.props.controller.ui;

    const onSignUp = this.props.model.user.user
      ? null
      : this.handleSignUp;

    return (
      <MainWrapper>
        {!model.loading && (
          <PageHeader coverImage={model.cover_image}>
            <h1>
              <TextNoOrphan value={model.page_title}/>
            </h1>
            <p>
              <TextNoOrphan value={model.page_subtitle}/>
            </p>
          </PageHeader>
        )}
        {!model.loading && (
          <div className={CareersPage.styles.content}>
            <div className={CareersPage.styles.sections}>
              {model.sections.map((section, index) => (
                <div key={index.toString()} className={CareersPage.styles.section}>
                  <div>
                    <h3><TextNoOrphan value={section.heading}/></h3>
                    <div style={{width: '100%'}}
                         dangerouslySetInnerHTML={{__html: PrismicDOM.RichText.asHtml(section.content)}}/>
                  </div>
                  {section.video && (
                    <div className={classes(CareersPage.styles.video, DiscoverPage.styles.video)}>
                      <div dangerouslySetInnerHTML={{__html: decodeURIComponent(section.video)}}/>
                    </div>
                  )}
                  {!section.video && (
                    <div>
                      <ResponsiveImageTile
                        className={CareersPage.styles.sectionImage}
                        identity={section.image}
                        ratio={constantGoldenRatio}
                        preload={preloadImage}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
            <PageHomeCTASeparator className={CareersPage.styles.ctaSeparator}/>
            {!!model.slug && (
              <div className={CareersPage.styles.cta}>
                <h3>{model.cta_title}</h3>
                <p>{model.cta_content}</p>
                {!model.typeform_url && onSignUp && (
                  <ButtonPill onClick={onSignUp} primary={true}>
                    {model.cta_button}
                  </ButtonPill>
                )}
                {model.typeform_url && (
                  <TypeformPopupButton typeformUrl={model.typeform_url}>
                    {model.cta_button}
                  </TypeformPopupButton>
                )}
              </div>
            )}
            {model.currentShow && (
              <div className={CareersPage.styles.openings}>
                <h3>{model.currentHeading}</h3>
                <p>{model.currentDescription}</p>
                <ul>
                  {model.currentOpenings.map((position, index) => (
                    <li key={index}>
                      <h4>{position.job_title}</h4>
                      <p dangerouslySetInnerHTML={{__html: PrismicDOM.RichText.asHtml(position.summary)}}/>
                      <ButtonPill primary={true} href={`/careers/${position.posting.slug}`} onClick={handleClickLink}>
                        Find out more
                      </ButtonPill>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {model.upcomingShow && (
              <div className={CareersPage.styles.openings}>
                <h3>{model.upcomingHeading}</h3>
                <p>{model.upcomingDescription}</p>
                <ul>
                  {model.upcomingPositions.map((position, index) => (
                    <li key={index}>
                      <h4>{position.job_title}</h4>
                      <p dangerouslySetInnerHTML={{__html: PrismicDOM.RichText.asHtml(position.summary)}}/>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </MainWrapper>
    )
  }

  handleSignUp = () => {
    this.props.controller.onboarding.openSignUpModal('/youtube');
  };

  static makeHref = (slug: string) => `/learn/${slug}`;

  static constants = {
    desktopMaxWidth: px(600)
  };

  static styles = {
    ...LearnPage.styles,
    openings: style(
      {
        width: percent(100),
        margin: '4rem auto',
        maxWidth: px(1280),
        $nest: {
          '& p': {
            margin: '0 0 1rem 0'
          },
          '& ul': {
            margin: 0,
            padding: '0 0 0 2rem'
          },
          '& h3': {
            color: colorBrand.toString(),
            fontSize: px(30),
            margin: '1rem 0',
          },
          '& h4': {
            fontSize: px(20),
            margin: '0.75rem 0',
          }
        }
      },
      mediaMobileOnly({
        padding: '0',
        $nest: {
          '&:last-child': {
            marginBottom: '2rem',
          },
        }
      }),
      mediaTablet({
        padding: '0 80px',
        margin: '80px 0',
        $nest: {
          '&:last-child': {
            marginBottom: '80px',
          },
        }
      })
    )
  }
}